export default {
  GET_SETTINGS_LOADING: 'GET_SETTINGS_LOADING',
  GET_SETTINGS__SUCCESS: 'GET_SETTINGS__SUCCESS',
  GET_SETTINGS_REJECT: 'GET_SETTINGS_REJECT',
  GET_SETTINGS_FAILED: 'GET_SETTINGS_FAILED',
  UPDATE_SETTINGS_LOADING: 'UPDATE_SETTINGS_LOADING',
  UPDATE_SETTINGS_SUCCESS: 'UPDATE_SETTINGS_SUCCESS',
  UPDATE_SETTINGS_REJECT: 'UPDATE_SETTINGS_REJECT',
  UPDATE_SETTINGS_FAILED: 'UPDATE_SETTINGS_FAILED'
};
